import React, { useContext } from 'react';
import get from 'lodash/get';
import styled from 'styled-components';

import HtmlEditor from './HtmlEditor/HtmlEditor';
import BoolControl from '../Bool';
import { Collapsed } from 'src/presentation/components/agent_desktop_components';
import { useAiToRephraseOverviewLink } from '../../../../SidekickActionsConstants';
import FormContext from 'src/presentation/contexts/FormContext';
import { StyledContent } from '@ad-scripts/presentation/components/common/collapse';

const Description = (
  <>
    Use AI to rephrase the question based on the Customer message. Learn more about the feature in our{' '}
    {useAiToRephraseOverviewLink}.
  </>
);

const AiRephraseControl = ({ disabled, placeholder }) => {
  const { workingState } = useContext(FormContext);

  const isActive = get(workingState, 'controlValues.rephraseAI', false);

  return (
    <>
      <BoolControl attr="controlValues.rephraseAI" description={Description} prompt="AI rephrase" disabled={disabled} />
      <StyledCollapsed isActive={isActive}>
        <HtmlEditor
          attr="controlValues.prompt"
          disabled={disabled}
          prompt="Rephrase instructions"
          placeholder={placeholder}
        />
      </StyledCollapsed>
    </>
  );
};

const StyledCollapsed = styled(Collapsed)`
  border-radius: 0;
  border: none;

  ${StyledContent} {
    padding: 0;
    margin-left: 24px;
  }
`;

export default AiRephraseControl;
